import { ref } from 'vue';

// Session-expired circuit breaker: a dead session means every in-flight or
// upcoming API call fails with 401/403. Without this, each failing request
// would trigger its own toast/redirect/logout. `triggerSessionExpired` trips
// once — the first 401/403 shows the popup, every other call (parallel or
// later) is a no-op until a full page reload (post-login) resets it.
export const sessionExpired = ref(false);
export const sessionExpiredMessage = ref('');

const DEFAULT_MESSAGE = 'Your session has expired. Please log in again to continue.';

export function triggerSessionExpired(message) {
  if (sessionExpired.value) return;

  // A guest who was never logged in gets 401s from plenty of endpoints —
  // that's just "not authenticated", not "your session expired". Only show
  // the popup when there was actually a logged-in session to lose.
  let hadSession = false;
  try {
    hadSession = !!localStorage.getItem('user');
  } catch {
    hadSession = false;
  }
  if (!hadSession) return;

  sessionExpiredMessage.value = message || DEFAULT_MESSAGE;
  sessionExpired.value = true;
}
